import { LicenseCode } from '@account-users/account/models/LicenseCode';
import { IToolInfo } from '@account-users/account/models/IToolInfo';
import { Permission } from '@account-users/account/models/Permission';
import { LicensePermissionList } from '@account-users/account/models/LicensePermissionList';

export function getAllPermissionsExceptCore(
  licensePermissions: LicensePermissionList[],
) {
  return [...licensePermissions]
    .filter((lp) => lp.code !== LicenseCode.Core)
    .sort((a, b) => (a.code >= b.code ? 1 : -1));
}

export function isAdmin(toolPermissions: IToolInfo[]) {
  const coreTool = toolPermissions.find(
    (tool) => tool.toolId === LicenseCode.Core,
  );
  const corePermissions = coreTool ? coreTool.permissions : [];

  return (
    corePermissions.includes(Permission.AccountCanManage) &&
    corePermissions.includes(Permission.AudienceAllResourcesManage)
  );
}

// Transform url to work with angular-jwt whitelisting.
// E.g. https://gw.au-stage.apsis.cloud/backoffice/ -> gw.au-stage.apsis.cloud.
export function getDomainFromUrl(url: string) {
  let domain = url;
  domain = domain.split('://', url.length)[1];
  domain = domain.split('/')[0];
  return domain;
}
